import { render } from "./ai-drop-down-tab.vue?vue&type=template&id=952f05a2"
import script from "./ai-drop-down-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-drop-down-tab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-drop-down-tab/ai-drop-down-tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "952f05a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('952f05a2', __exports__)) {
    api.reload('952f05a2', __exports__)
  }
  
  module.hot.accept("./ai-drop-down-tab.vue?vue&type=template&id=952f05a2", () => {
    api.rerender('952f05a2', render)
  })

}


export default __exports__